import { ProfileIconMenu as ProfileIconMenuWSC } from '@trackman/web-shared-components';
import { AppSwitcherWrapper } from 'components/AppSwitcher/AppSwitcherStyles';
import { useStores } from 'index';
import { observer } from 'mobx-react-lite';
import React from 'react';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProfileIconMenu = observer(({ setDisplayContent }: Props) => {
  const ss = useStores().startupStore;
  const buildNumber = ss.buildInfo?.buildNumber;

  return ss.bearerTokenProfileInfo ? (
    <AppSwitcherWrapper>
      <ProfileIconMenuWSC
        label='Profile'
        name={ss.bearerTokenProfileInfo.name}
        surname={ss.bearerTokenProfileInfo.surname}
        profilePhotoUrl={ss.profile?.profilePhotoUrl}
        accountUrl={ss.config?.myAccountUrl}
        logoutUrl={ss.config?.logoutUrl ? ss.config.logoutUrl + '?returnUrl=' + window.origin : undefined}
        userOrganization={ss.bearerTokenProfileInfo.organizationName}
        onMenuItemClick={(menuItemUrl) => {
          setDisplayContent(false);
          window.location.href = menuItemUrl;
        }}
        supportUrl='https://trackman.zendesk.com/hc/en-us'
        footerText={buildNumber ? `Build number: ${buildNumber}` : undefined}
      />
    </AppSwitcherWrapper>
  ) : null;
});

export default ProfileIconMenu;
